import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

export default withStyles({
  root: {
    minHeight: 'calc(100vh - 143px)',
  },
})(Grid);
